import { render, staticRenderFns } from "./EaseComponent.vue?vue&type=template&id=24bba1c2"
import script from "./EaseComponent.vue?vue&type=script&lang=js"
export * from "./EaseComponent.vue?vue&type=script&lang=js"
import style0 from "./EaseComponent.vue?vue&type=style&index=0&id=24bba1c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports